import * as React from 'react'
import { navigate } from 'gatsby'
import { SelectWrapper } from './style'

// @ts-ignore
export const LanguageSwitcher = ({ lang, localePath, altLang }) => {
  const alternateLanguages = (currentLang: any) => {
    let alternate_languages
    switch (currentLang) {
      case 'en-us':
        return (alternate_languages = [
          {
            lang: 'fr-fr',
          },
        ])
      case 'fr-fr':
        return (alternate_languages = [
          {
            lang: 'en-us',
          },
        ])
      default:
        return (alternate_languages = [
          {
            lang: 'en-us',
          },
          {
            lang: 'fr-fr',
          },
        ])
    }
  }

  const currentLangOption = <option value={lang}>{lang.slice(0, 2).toUpperCase()}</option>

  const alternateLangOptions =
    altLang.length === 0
      ? alternateLanguages(lang).map(
          // @ts-ignore
          (altLang, index) => (
            <option value={altLang.lang} key={`alt-lang-${index}`}>
              {altLang.lang.slice(0, 2).toUpperCase()}
            </option>
          ),
        )
      : altLang.map(
          // @ts-ignore
          (altLang, index) => (
            <option value={altLang.lang} key={`alt-lang-${index}`}>
              {altLang.lang.slice(0, 2).toUpperCase()}
            </option>
          ),
        )

  const handleLangChange = () => {
    if (localePath.includes('/fr/blog')) {
      navigate(`/blog`)
    }
    if (!localePath.includes('/fr/blog')) {
      navigate(`/fr/blog`)
    }
  }

  return (
    <SelectWrapper>
      <select id="lang" name="lang" defaultValue={lang} onChange={handleLangChange}>
        {currentLangOption}
        {alternateLangOptions}
      </select>
    </SelectWrapper>
  )
}
